import { render, staticRenderFns } from "./ResumeTimeline.vue?vue&type=template&id=0b2dc31c&scoped=true"
import script from "./ResumeTimeline.vue?vue&type=script&lang=js"
export * from "./ResumeTimeline.vue?vue&type=script&lang=js"
import style0 from "./ResumeTimeline.vue?vue&type=style&index=0&id=0b2dc31c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b2dc31c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTimeline } from 'vuetify/lib/components/VTimeline';
import { VTimelineItem } from 'vuetify/lib/components/VTimeline';
installComponents(component, {VBtn,VCard,VCardTitle,VIcon,VTimeline,VTimelineItem})
